import { Service, inject } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {GoogleService} from "./google-service";
import {EntityKey} from "../entity/entity";
import {Observable} from "rxjs";
import {EntityBreak} from "../entity/entity-break";
import {WarrantyLine} from "../model/warranty-line";

@Service()
export class WarrantyLineService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getWarrantyLines(entityId: string, entityRevision: number): Observable<WarrantyLine[]> {
    let url = this.urlBase + 'warrantyline/' + entityId + '/' + entityRevision;
    return this.http.get<WarrantyLine[]>(url, {headers: this.getRequestHeaders()});
  }

  public getWarrantyLine(entityId: string, entityRevision: number, entityLine: string): Observable<WarrantyLine> {
    let url = this.urlBase + 'warrantyline/' + entityId + '/' + entityRevision + '/' + entityLine;
    return this.http.get<WarrantyLine>(url, {headers: this.getRequestHeaders()});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }
}
